import { HashRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ContentWrapper, MainLayoutWrapper, MainWrapper, SideBarWrapper, StatusBarWrapper, RouterWrapper, MainContentLayoutWrapper } from "./Main.styled";
import DeviceManagement from "../device-management/DeviceManagement";
import MainSideBar from "./components/sidebar/MainSideBar";
import StatusBar from "./components/statusbar/StatusBar";
import AlarmEventManagement from "../alarm-event-management/AlarmEventManagement";
import UserManagement from "../user-management/UserManagement";
import MessageServiceLoader from "../../../services/message/MessageServiceLoader";
import DeviceDetails from "../device-management/components/device-details/DeviceDetails";

interface MainProps {

}

const Main: React.FC<MainProps> = (props)=> {
    // router
    let routes = [
        {
            path: '/',
            element: <DeviceManagement />,
        },
        {
            path: '/index.html',
            element: <DeviceManagement />,
        },
        
        {
            path: '/device-management/*',
            element: <DeviceManagement />
        },
        {
            path: "device-management/device/:deviceId",
            element: <DeviceDetails />
        },
        {
            path: '/alarm-events',
            element: <AlarmEventManagement />
        },

        {
            path : '/user-management',
            element: <UserManagement />
        },
    ];

    // render
    return (
        <HashRouter>
            <MainWrapper>
                <UserAccessRedirect />
                <MessageServiceLoader />
                <Routes>
                    <Route path="/*" element={
                        <MainLayoutWrapper>
                            <MainContentLayoutWrapper>
                                <StatusBarWrapper>
                                    <StatusBar />
                                </StatusBarWrapper>

                                <SideBarWrapper>
                                    <MainSideBar />
                                </SideBarWrapper>

                                <ContentWrapper>
                                    <RouterWrapper>
                                        <Routes>
                                        {
                                            routes.map((route)=> {
                                                return (
                                                    <Route key={route.path} path={route.path} element={route.element}></Route>
                                                )
                                            })
                                        }
                                        </Routes>
                                    </RouterWrapper>
                                </ContentWrapper>
                            </MainContentLayoutWrapper>
                        </MainLayoutWrapper>
                    } />
                </Routes>
            </MainWrapper>
        </HashRouter>
    )
};

interface UserAccessRedirectProps {
    
}

let UserAccessRedirect: React.FC<UserAccessRedirectProps> = (props)=> {
    // users access control
    let navigate = useNavigate();
    let location = useLocation();
    return <div style={{position: 'absolute', visibility: 'hidden', width: '0', height: '0'}}></div>
};

export default Main;
